import { create } from "zustand";

interface DefineBusinessHourState {
  isCompleted: boolean;
  setCompleted: (isInvited: boolean) => void;
}

export const useDefineBusinessHourStore = create<DefineBusinessHourState>(
  (set) => ({
    isCompleted: false,
    setCompleted: (isCompleted) => set({ isCompleted }),
  })
);
